import { render, staticRenderFns } from "./DatabasePicker.vue?vue&type=template&id=1715f308&scoped=true"
import script from "./DatabasePicker.vue?vue&type=script&lang=ts"
export * from "./DatabasePicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1715f308",
  null
  
)

export default component.exports